import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-saida-client',
  templateUrl: './dialog-saida-client.component.html',
  styleUrls: ['./dialog-saida-client.component.scss']
})
export class DialogSaidaClientComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogSaidaClientComponent>) { }

  ngOnInit(): void {
  }

  fecharDialog(): void {
    this.dialogRef.close();
  }

}
